import ProductHeader from './ProductHeader'

export default ProductHeader
